import { Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { LayoutComponent } from './components/layout/layout.component';
import { MonitorComponent } from './components/monitor/monitor.component';
import { ProfilesComponent } from './components/profiles/profiles.component';
import { SettingsComponent } from './components/settings/settings.component';
import { DemandImportComponent } from './components/demand-import/demand-import';
import { ProductReplicatorComponent } from './components/product-replicator/product-replicator';
import { AlloraIntegrationComponent } from './components/allora-integration/allora-integration';
import { authGuard } from './guards/auth.guard';

export const routes: Routes = [
    { path: 'login', component: LoginComponent },
    {
        path: '',
        component: LayoutComponent,
        canActivate: [authGuard],
        canActivateChild: [authGuard],
        children: [
            { path: '', redirectTo: 'monitor', pathMatch: 'full' },
            {
                path: 'monitor',
                component: MonitorComponent,
                data: { roles: ['Admin', 'Operator', 'Viewer'] }
            },
            {
                path: 'profiles',
                component: ProfilesComponent,
                data: { roles: ['Admin'] }
            },
            {
                path: 'settings',
                component: SettingsComponent,
                data: { roles: ['Admin'] }
            },
            {
                path: 'demand-import',
                component: DemandImportComponent,
                data: { roles: ['Admin', 'Operator', 'Viewer'] }
            },
            {
                path: 'product-replicator',
                component: ProductReplicatorComponent,
                data: { roles: ['Admin', 'Operator', 'Viewer', 'ProductSyncOperator', 'ProductSyncViewer'] }
            },
            {
                path: 'allora-integration',
                component: AlloraIntegrationComponent,
                data: { roles: ['Admin', 'Operator', 'Viewer', 'AlloraSyncOperator', 'AlloraSyncViewer'] }
            }
        ]
    },
    { path: '**', redirectTo: 'login' }
];
